export enum UserStatus {
  CREATED = '',
  ACTIVE = 'active',
  BLOCKED = 'blocked',
  ARCHIVED = 'archived',
}
